import {RaisedButton} from "material-ui";
import React, {Component} from 'react';
import axios from "axios";
import {reduxForm, Field, SubmissionError} from 'redux-form';
import {TextField} from 'redux-form-material-ui';
import {connect} from 'react-redux'
import ConfirmEmail from './ConfirmEmail';
import {Redirect} from 'react-router-dom';
import FacebookLogin from './react-facebook-login/facebook';
import GoogleLogin from 'react-google-login';
import {sendSocialLoginRequest} from "store/auth/actions";
import logo from 'components/logo.png';
import { translate } from 'react-i18next';
import $ from 'jquery';
import './login.css';
import {getBrowserInfo} from 'utils';
import renderHTML from 'react-render-html';


import {sendEmailRequest, sendEmailSuccess, sendEmailError} from 'store/auth/actions';


class LoginForm extends Component {
    render() {
        const t = this.props.t;
        return (
            <form onSubmit={this.props.handleSubmit(this.props.submitForm)}>
                <div className="emailLogin">
                    <Field style={{width: '180px'}} name="email" component={TextField} hintText={t('login_email_adress')}/>
                    <RaisedButton style={{
                        marginLeft: '10px',
                        marginTop: '5px',
                        marginRight: '5px',
                        float: 'right'
                    }} label={t('log_in')} primary={true} type="submit" disabled={this.props.submitting}/>
                </div>
            </form>
        )
    }
}

LoginForm = translate()(reduxForm({
    form: 'loginForm'
})(LoginForm));


const sendForm = (values) => {
    return (dispatch) => {
        dispatch(sendEmailRequest());
        const browserInfo = getBrowserInfo()
        return axios.post(process.env.REACT_APP_API_BASE_URL + 'user/device/assign/email/', {
            device_name: browserInfo['version'],
            device_manufacturer: browserInfo['name'],
            platform: 'web',
            email: values.email,

        }).then((response) => {
            dispatch(sendEmailSuccess(response.data, values.email));
        }).catch((error) => {
            dispatch(sendEmailError(error));
            if (error.response) {
                let r = error.response;
                if (r.status === 400) {
                    throw new SubmissionError(r.data)
                }
            }
        });
    }
};


class LoginPage extends Component {

    componentDidMount() {
        $('body').addClass('login');
    }

    componentWillUnmount() {
        $('body').removeClass('login');
    }

    submitForm(values, dispatch) {
        return dispatch(sendForm(values));
    };

    responseFacebook = (response) => {

        if (response.accessToken === undefined) {
            return;
        }
        if (response.email === undefined || response.email === null) {
            alert(this.props.t('login_fb_email_permission_is_required'));
            return;
        }
        this.props.loginSocial('facebook', response);
    };

    responseGoogle = (response) => {
        this.props.loginSocial('google', response);
    };

    render() {
        const header = <div className="header">
            <img alt="Vocabulary Miner" src={logo}/>
            <h1 style={{fontSize: '25pt', fontWeight: '500'}}>
                Vocabulary Miner
            </h1>
            <h2 style={{fontSize: '14pt', fontWeight: '500'}}>
                {renderHTML(this.props.t('login_second_level_head'))}
            </h2>
            <p style={{fontSize: '12pt', fontWeight: '500', margin: '0px'}}>
                {renderHTML(this.props.t('login_header_description_1',{
                        1: '<a target="_blank" href="https://vocabulary-miner.com/make-flashcards-in-the-flashcard-app/">',
                        2: '</a>'
                    })
                )}
            </p>
            <p style={{fontSize: '12pt', fontWeight: '500', margin: '5px'}}>
                {renderHTML(this.props.t('login_header_description_2',{
                    1: '<a target="_blank" href="https://apps.apple.com/cz/app/vocabulary-miner/id1114266792">AppStore</a>',
                    2: '<a target="_blank" href="https://play.google.com/store/apps/details?id=com.vocabularyminer.android">Google Play</a>'
                })
                )}
            </p>
        </div>;
        if (!this.props.auth.token) {
            return (
                <div className="loginPage">
                    {header}
                    <div style={{paddingTop: '70px'}}>
                        <p style={{fontSize: '20px', textAlign: 'center',}}>{this.props.t('login_buttons_title')}</p>
                        <FacebookLogin
                            appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                            autoLoad={false}
                            fields="email"
                            scope={"public_profile, email"}
                            callback={this.responseFacebook}
                            size={"small"}
                            textButton={"FACEBOOK"}
                            returnScopes={true}
                            reRequest={true}
                        /> <br/><br/>
                        <GoogleLogin
                            clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                            buttonText="GOOGLE"
                            onSuccess={this.responseGoogle}
                            onFailure={(response) => {
                                console.log(response)
                            }}
                            autoLoad={false}
                            className={'loginGoogle'}
                        />
                        <LoginForm submitForm={this.submitForm}/>

                    </div>
                </div>

            )
        }

        if (this.props.auth.token && !this.props.auth.isVerified) {
            return (
                <div className="loginPage">
                    {header}
                    <div style={{paddingTop: '100px'}}>
                        <ConfirmEmail auth={this.props.auth}/>
                    </div>
                </div>
            )
        }
        return <Redirect to="/"/>
    }

}


const mapStateToProps = (state) => {
    return {auth: state.auth}
};

const mapDispatchToProps = (dispatch) => {
    return {
        loginSocial: (provider, payload) => {
            return dispatch(sendSocialLoginRequest(provider, payload));
        }

    }
};


export default translate()(connect(mapStateToProps, mapDispatchToProps)(LoginPage));



// WEBPACK FOOTER //
// ./src/components/auth/LoginPage.js